import { Toast } from '../../../components/Common/Toast';

/**
 * Resolves a WordPress project parameter (which might be a slug or an ID)
 * into a numeric WP project ID.
 * 
 * If the input is already numeric, it returns it as is.
 * If it's a slug, it queries the WP REST API to find the corresponding ID.
 * 
 * @param projectParam The project slug or ID from URL or local storage
 * @returns The resolved numeric ID as a string, or null if not found/invalid
 */
export const resolveWpProjectIdFromProjectParam = async (projectParam: string | null): Promise<string | null> => {
  if (!projectParam) {
    return null;
  }

  // If it's already a numeric ID, return it as is
  if (/^\d+$/.test(projectParam)) {
    return projectParam;
  }

  try {
    const response = await fetch(`https://buildmystory.com/wp-json/wp/v2/project?slug=${encodeURIComponent(projectParam)}`);
    
    if (!response.ok) {
      console.error('Failed to fetch WP project:', response.statusText);
      return null;
    }
    
    const data = await response.json();
    
    if (Array.isArray(data) && data.length > 0 && data[0].id) {
      return data[0].id.toString();
    }
    
    // If we got here, the slug didn't match any project
    console.warn(`No WP project found for slug: ${projectParam}`);
    Toast('Invalid project link. Proceeding without project attribution.', true);
    return null;
  } catch (error) {
    console.error('Error resolving WP project slug:', error);
    return null;
  }
};
